import merge from 'lodash.merge';

import { createConfig as createProvidersEnvironmentConfig } from '#shared/util/providersEnvironment.js';

import devEnv from './dev.js';

const localEnv = merge({}, devEnv, {
	providers: {
		checkout: {
			credentials: {
				apiSecret: process.env.CHECKOUT_API_SECRET_LOCAL
			},
			variables: {
				apiEndpoint: `${IS_SERVER ? 'https://checkout-local.avast.com' : ''}/api/v1`
			}
		}
	}
});
localEnv.providers = createProvidersEnvironmentConfig('local', localEnv.providers);

export default localEnv;
